<template>
  <section>
    <div class="box">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
          <h3>Nuvem Shop</h3>
          <div class="margin-top-s">
              Status:
              <span v-if="hasOneIntegrationActive">
                <b style="color: green;">ATIVA</b>
              </span>
              <span v-else>
                <b style="color: red;">DESATIVADA</b>
                <p>
                  <small>Entre com sua conta da Nuvem Shop para Ativar.</small>
                </p>
              </span>
            </div>
        </div>
        <div class="flex-1 flex end">
          <div>
              <div>
                <div v-if="!profiles || profiles && profiles.length === 0" class="nuvemshop connect" @click="createLoginNuvemShopOauth2()">
                  Entrar com a NuvemShop
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
      <div class="box-content">
        <div class="list-account">
          <!-- list accounts -->
          <p>
            Lista das lojas
          </p>
          <ul class="margin-top-l">
            <li v-for="(pro, index) in profiles" :key="index">
              <div class="flex middle">
                <div class="flex-3">
                  {{ pro.name }} - {{ pro.email }}
                </div>
                <div class="flex-1">
                  <div class="flex end">
                    <div v-if="pro.status === 'ACTIVE'" class="button secondary" @click="deleteIntegration(pro)">Remover Loja</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loadingProfiles">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  getIntegrations,
  initNuvemShopOauth2,
  // saveIntegration,
  // getAccountsFacebookAds,
  deleteIntegration,
} from "@/services/integration";

export default {
  components: { 

  },
  name: "nuvemshop",
  data() {
    return {
      status: "DISABLED",
      profiles: [],
      accountsIntegration: [],
      listAccountsFacebookAds: [],
      newAccountFacebookAds: "",
      detectTokenDataOauth: null,
      showModalDelete: false,
      showModalDeleteIntegration: false,
      modalNewAccount: false,
      loading: false,
      loadingProfiles: false,
      timerToRequest: 3000,
    };
  },
  computed: {
    ...mapState({ account: (state) => state.account }),
    hasIntegration() {
      return this.profiles && this.profiles.length > 0;
    },
    hasOneIntegrationActive() {
      let status = false

      this.profiles.forEach(p => {
        status = p.status == 'ACTIVE'
        if (status) return
      })

      return status
    }
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.detectTokenDataOauth);
  },
  methods: {
    deleteIntegration(integration) {
      deleteIntegration(integration.id)
        .then(() => {
          this.profiles = this.profiles.filter((pro) => { return pro.id != integration.id })

          this.$toast.success({
            title: "Sucesso",
            message: "Integração removida com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar deletar integração",
          });
        });
    },
    getData(notLoading) {
      if (!notLoading) {
        this.loadingProfiles = true;
      }

      getIntegrations()
        .then((result) => {
          // detect change profile list
          this.profiles = result.nuvemshop
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          console.log('error', error)
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar buscar integrações",
          });
        })
        .finally(() => {
          this.loadingProfiles = false;
        });
    },
    createLoginNuvemShopOauth2() {
      initNuvemShopOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.getData(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-account {
  ul {
    list-style-type: none;
    li {
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--border);
    }
  }
}



.nuvemshop {
    cursor: pointer;
    font-family: Lucida Grande, Helvetica Neue, Helvetica, Arial, sans-serif;
    display: inline-block;
    font-size: 14px;
    font-weight: 800;
    padding: 15px 30px 15px 30px;
    background: #0050c3;
    color: #fff;
    text-shadow: 0 -1px 0 rgba(0,0,20,.4);
    text-decoration: none;
    line-height: 1;
    position: relative;
    border-radius: 5px;
}

</style>
